export const uuid = () => {
  return (
    // 当前时间戳拼接 4 位随机数，再转 36 进制 ---→ 11 位字符串（含数字和小字母）
    Number(Date.now().toString() + Math.random().toFixed(4).slice(2).toString()).toString(36)
  );
};

export const uuidby = (id: string) => {
  let num = Number.parseInt(id, 36);
  return (num + 9999).toString(36);
}